import type { AssignmentJobResponseType } from './AssignmentJobApi';
import type { JobResponseType, JobServiceAttributesType } from '../Jobs/types';
import type { RoutePointExtendedType, RoutePointSimpleType } from '../../utilities/RoutePointsApi';
import { AssignmentJobApi } from './AssignmentJobApi';
import { JobApi } from '../Jobs/JobApi';
import { get } from 'svelte/store';
import { api } from '../../../stores/api';
import { planning } from '../../../stores/store';
import { scenarioManager } from '../../../stores/store';
import { jobs } from '../../../stores/store';
import { features } from '../../shared/Features/features';
import { _ } from 'svelte-i18n';
import { MenuContextCustomActions } from '../MenuDropdown/MenuContextCustomActions';
import { Job } from '../Jobs/Job';
import { RoutePointExtendedSchema } from '../../utilities/RoutePointsApi';
import { unlockAssignmentIfPossible } from './unlockAssignmentIfPossible';
import { DeliveriesMenuActions } from './PageDeliveries2/DeliveriesMenuActions';
import { Assignment } from './Assignment';
import { DeliveriesBulkActions } from './PageDeliveries2/DeliveriesBulkActions';
import { openModal } from 'svelte-modals';
import IconPlanningStep3 from '../../shared/Icons/IconPlanningStep3.svelte';
import IconRemoveWarning from '../../shared/Icons/IconRemoveWarning.svelte';
import IconVehicle from '../../shared/Icons/IconVehicle.svelte';
import IconCalendar from '../../shared/Icons/IconCalendar.svelte';

export class AssignmentJob {
    public assignmentJob: AssignmentJobResponseType;
    private routePoint: RoutePointExtendedType | null = null;
    private _isBusy: boolean = false;
    private visible: boolean = true;
    private _menu: MenuContextCustomActions = new MenuContextCustomActions();

    public setMenu(menu: MenuContextCustomActions): this {
        this._menu = menu;
        return this;
    }

    public getMenu(): MenuContextCustomActions {
        return this._menu;
    }

    public setBusy(busy: boolean): this {
        this._isBusy = busy;
        return this;
    }

    public isBusy(): boolean {
        return this._isBusy;
    }
    public setVisibility(visible: boolean): this {
        this.visible = visible;
        return this;
    }

    public setRoutePoint(routePoint: RoutePointExtendedType) {
        this.routePoint = RoutePointExtendedSchema.parse(routePoint);
    }

    public updateRoutePointBySimpleData(simpleRoutePoint: RoutePointSimpleType) {
        if (this.routePoint) {
            this.routePoint.details = JSON.parse(JSON.stringify(simpleRoutePoint.details));
        } else {
            this.routePoint = {
                id: simpleRoutePoint.id,
                details: simpleRoutePoint.details,
                /* next fields are required by type RoutePointExtendedType */
                assignment_id: this.assignmentJob.assignment_id,
                address_id: null,
                geom: { type: 'Point', coordinates: [0, 0] },
                revision: '',
                point_order: 0,
                jobs: null,
                address_geocoded: null,
                address_imported: null,
                job_delay: null,
            };
        }
    }

    public getRoutePoint(): RoutePointExtendedType | null {
        return this.routePoint;
    }

    public isVisible(): boolean {
        return this.visible;
    }

    constructor(assignmentJob: AssignmentJobResponseType) {
        this.assignmentJob = assignmentJob;
    }

    public set(assignmentJob: AssignmentJobResponseType): AssignmentJob {
        this.assignmentJob = assignmentJob;
        return this;
    }

    public update(assignmentJob: AssignmentJob): AssignmentJob {
        this.assignmentJob = assignmentJob.assignmentJob;
        return this;
    }

    public isNewlyAdded(): boolean {
        return (this.assignmentJob?.job && this.assignmentJob.job.newly_added) || false;
    }

    public isOptional(selectedDay: string): boolean {
        // MM - czy mógłbyś podświetlać jako opcjonalne te nieprzypisane, które nie mają daty realizacji, ale data od i data do zawiera wybrany dzień? Nie jestem w stanie łatwo tego zrobić w backendzie na razie.
        let d: Date = new Date(selectedDay);
        let dateFrom: Date | null = this.assignmentJob?.job?.start_date
            ? new Date(this.assignmentJob?.job?.start_date)
            : null;
        let dateTo: Date | null = this.assignmentJob?.job?.end_date
            ? new Date(this.assignmentJob?.job?.end_date)
            : null;
        let targetDate: Date | null = this.assignmentJob?.job?.target_date
            ? new Date(this.assignmentJob?.job?.target_date)
            : null;
        if (
            targetDate === null &&
            dateFrom !== null &&
            dateFrom <= d &&
            dateTo !== null &&
            dateTo >= d
        ) {
            return true;
        }
        return false;
        // let optional: boolean = this.assignmentJob?.job?.target_date===null && this.
        // return this.assignmentJob?.details && this.assignmentJob.details.optional || false;
    }

    public getServiceAttributes() {
        return this.assignmentJob?.details?.service_attributes || null;
    }

    public setServiceAttributes(serviceAttributes: JobServiceAttributesType | undefined) {
        if (this.assignmentJob) {
            if (!this.assignmentJob.details) {
                this.assignmentJob.details = {
                    optional: false,
                    overdue: false,
                    in_realisation: false,
                };
            }
            this.assignmentJob.details.service_attributes = serviceAttributes;
        }
    }

    public isOverdue(): boolean {
        return (this.assignmentJob?.details && this.assignmentJob.details.overdue) || false;
    }

    public isInRealisation(): boolean {
        return (this.assignmentJob?.details && this.assignmentJob.details.in_realisation) || false;
    }

    public hasSuggestedAssignment(): boolean {
        return (
            (this.assignmentJob.suggested_assignment_id !== null &&
                this.assignmentJob.suggested_assignment_id >= 0) ||
            false
        );
    }

    public getSuggestedAssignmentId(): number | null {
        return this.assignmentJob.suggested_assignment_id || null;
    }

    public removeSuggestedAssignment() {
        this.assignmentJob.suggested_assignment_id = 0;
    }

    public getId() {
        return this.assignmentJob.id;
    }

    public getJobId(): number {
        // return typeof this.assignmentJob?.job?.id !== 'undefined' ? this.assignmentJob.job.id : -1;
        return typeof this.assignmentJob?.job_id !== 'undefined' ? this.assignmentJob.job_id : -1;
    }

    // public async reload() {
    //     let aj = await AssignmentJobApi.getOne(get(api), this.assignmentJob.id);
    //     if (aj) {
    //         this.set(aj);
    //     } else {
    //         console.error('AssignmentJob.reload: assignment job not found');
    //     }
    //     return this;
    // }

    public async loadByJobId(jobId: number) {
        console.log('loadByJobId, jobId', jobId);
        let aj = await AssignmentJobApi.getByJobId(get(api), jobId).catch(err => {
            console.error('AssignmentJob.loadByJobId: error', err);
        });
        if (aj) {
            console.log('loadByJobId, new assignmentJob.id: ', aj.id);
            this.set(aj);
        } else {
            console.error(
                'loadByJobId, AssignmentJob.loadByJobId: assignment job not found for jobId',
                jobId
            );
        }
        return this;
    }

    public setAsUnnassigned(): void {
        this.assignmentJob.assignment_id = 0;
        this.assignmentJob.tactical_plan_rule_id = null;
    }

    public getJob(): JobResponseType | null {
        return this.assignmentJob?.job || null;
    }

    public getJobClass(): Job | null {
        if (this.assignmentJob.job === null) {
            return null;
        }
        return new Job().set(this.assignmentJob.job);
    }

    public setJobProcessStatus(process_status: number) {
        if (this.assignmentJob?.job) {
            this.assignmentJob.job.process_status = process_status;
        }
    }

    public getJobType(): string | null | undefined {
        return this.assignmentJob?.job?.special_attributes?.delivery_or_collection;
    }

    public getAssignmentId(): number {
        return this.assignmentJob.assignment_id;
    }

    public getCity(): string {
        return this.getGeocodedCity() || this.assignmentJob?.job?.address_attributes?.city || '';
    }

    public getGeocodedCity(): string | null {
        return this.assignmentJob?.job?.computed_address?.city || null;
    }

    public getGeocodedStreet(): string | null {
        return this.assignmentJob?.job?.computed_address?.street || null;
    }

    public getStreet(): string {
        return (
            this.getGeocodedStreet() || this.assignmentJob?.job?.address_attributes?.street || ''
        );
    }

    public getGeocodedHouse(): string | null {
        return this.assignmentJob?.job?.computed_address?.house || null;
    }

    public getHouse(): string {
        return this.getGeocodedHouse() || this.assignmentJob?.job?.address_attributes?.house || '';
    }

    public getStartDate(): string {
        return (this.assignmentJob?.job?.start_date && this.assignmentJob.job.start_date) || '';
    }

    public getEndDate(): string {
        return (this.assignmentJob?.job?.end_date && this.assignmentJob.job.end_date) || '';
    }

    public getTargetDate(): string {
        return (this.assignmentJob?.job?.target_date && this.assignmentJob.job.target_date) || '';
    }

    public isAdHoc(): boolean {
        return this.assignmentJob?.job?.ad_hoc || false;
    }

    public setMenuOptions(assignment: Assignment, handlers: any): MenuContextCustomActions {
        let assignmentJobIsAssigned = DeliveriesMenuActions.assignmentJobIsAssigned(
            this,
            assignment
        );
        // (assignment.isDefault() && assignment.getId() === assignmentJob.getAssignmentId()) ||
        // assignmentJob.getAssignmentId() !== 0;
        let assignToActionText = get(_)('Assign to');
        if (assignmentJobIsAssigned) {
            assignToActionText = get(_)('Reassign to');
        }

        let rejectActionText = get(_)('Reject');
        if (assignmentJobIsAssigned && assignment.isDefault()) {
            rejectActionText = get(_)('Reject from route');
        }

        let select_another_assignment_label = assignToActionText+' '+get(_)('another vehicle');
        if (!assignment.isDefault()) {
            select_another_assignment_label = get(_)('Assign to vehicle');
        }

        //resetBulkActionSelection();

        this._menu.reset();
        this._menu.addAction({
            id: 'assign_to_last_used',
            label: `${assignToActionText} <span style="font-width:600;">${
                get(planning).lastUsedAssignment
                    ? get(planning).lastUsedAssignment?.getVehicleName()
                    : '[brak pojazdu]'
            }</span> (${get(_)('last_used')})`,
            disabled: false,
            visible:
                get(planning).lastUsedAssignment !== null &&
                get(planning).lastUsedAssignment?.getId() !== assignment.getId(),
            icon: IconPlanningStep3,
            visibleInContextMenu: true,
            onClick: () => {
                unlockAssignmentIfPossible(
                    assignment,
                    (() => {
                        if (get(planning).lastUsedAssignment !== null) {
                            console.log('assign_to_last_used, a', this.getJobId());
                            DeliveriesBulkActions.onRouteSelect(
                                this.getJobId(),
                                this.hasSuggestedAssignment(),
                                get(planning).lastUsedAssignment?.getId(),
                                get(planning).lastUsedAssignment
                            ).then((async () => {
                                console.log('assign_to_last_used, b', this.getJobId());
                                if (assignment.getId() !== get(planning).lastUsedAssignment?.getId()) {
                                    this.setVisibility(false);
                                }
                                this.setBusy(true);
                                if (typeof(handlers?.assign_to_last_used) == 'function') {
                                    await handlers.assign_to_last_used(false, assignment, get(planning).lastUsedAssignment);
                                }
                                get(planning).lastUsedAssignment.setLocked(false);
                                await DeliveriesBulkActions.doAssign(
                                    get(api),
                                    get(planning).lastUsedAssignment?.getId(),
                                    [this.getJobId()],
                                    'selected',
                                    {},
                                    get(planning).selectedDay
                                );
                                try {
                                    assignment = await assignment.reload();
                                    await this.loadByJobId(
                                        this.getJobId()
                                    );
                                } catch (e) {
                                    console.error('Cannot reload assignment', e);
                                }

                                if (typeof(handlers?.assign_to_last_used) == 'function') {
                                    await handlers.assign_to_last_used(true, assignment, get(planning).lastUsedAssignment);
                                }

                                this.setBusy(false);
                            }).bind(this));
                        } else {
                            throw new Error('Last used assignment is null (it should not be here)');
                        }
                    }).bind(this)
                );
            },
            subMenu: null,
            subMenuIsOpen: false,
        });
        this._menu.addAction({
            // this action should be only visible for default assignments
            id: 'assign',
            label:
                assignToActionText +
                ' <span style="font-width:600;">' +
                assignment.getVehicleName() +
                '</span>',
            disabled: false,
            visible: DeliveriesMenuActions.deliveryCanBeAssigned(this, assignment),
            icon: IconPlanningStep3,
            visibleInContextMenu: true,
            onClick: () => {
                DeliveriesBulkActions.onRouteSelect(
                    this.getJobId(),
                    this.hasSuggestedAssignment(),
                    assignment.getId(),
                    assignment
                ).then((async () => {
                        get(planning).lastUsedAssignment = assignment;
                        planning.set(get(planning));
                        this.setBusy(true);
                        if (typeof(handlers?.assign) == 'function') {
                            await handlers.assign(false, null, assignment);
                        }
                        let assignedResult = await DeliveriesBulkActions.doAssign(
                            get(api),
                            assignment.getId(),
                            [this.getJobId()],
                            'selected',
                            {},
                            get(planning).selectedDay
                        ).catch(e => {
                            console.error('doAssign', e);
                        });
                        if (assignedResult?.assigned <= 0) {
                            alert('Nie udało się przypisać zlecenia do pojazdu');
                        }

                        try {
                            assignment = await assignment.reload();
                        } catch (e) {
                            console.error(e);
                        }
                        await this.loadByJobId(this.getJobId());

                        if (typeof(handlers?.assign) == 'function') {
                            await handlers.assign(true, null, assignment);
                        }
                        this.setBusy(false);
                    }).bind(this),
                    () => {
                        console.log('Assignment is locked, user dont want to unlock');
                    }
                );
            },
            subMenu: null,
            subMenuIsOpen: false,
        });
        this._menu.addAction({
            // this action should be only visible for default assignments
            id: 'assign_suggestion',
            label: `${assignToActionText} ${assignment.getVehicleName() || '[brak pojazdu]'} (${get(_)('best')})`,
            disabled: !this.hasSuggestedAssignment(),
            visible: assignment.getVehicleName() !== '' && !assignment.isDefault(),
            icon: IconPlanningStep3,
            visibleInContextMenu: true,
            onClick: () => {
                DeliveriesBulkActions.onRouteSelect(
                    this.getJobId(),
                    this.hasSuggestedAssignment(),
                    assignment.getId(),
                    assignment
                ).then(async () => {
                        console.log('Assignment is locked, but user want to unlock it');
                        // assignSuggestionTo();
                        this.setBusy(true);
                        if (typeof(handlers?.assign_suggestion) == 'function') {
                            await handlers.assign_suggestion(false, null, assignment);
                        }
                        let assignedResult = await DeliveriesBulkActions.doAssign(
                            get(api),
                            assignment.getId(),
                            [this.getJobId()],
                            'selected',
                            {},
                            get(planning).selectedDay
                        ).catch(e => {
                            console.error('doAssign', e);
                        });
                        if (assignedResult?.assigned <= 0) {
                            alert('Nie udało się przypisać zlecenia do pojazdu');
                        }
                        await this.loadByJobId(this.getJobId());
                        try {
                            assignment = await assignment.reload();
                        } catch (e) {
                            console.error(e);
                        }
                        if (typeof(handlers?.assign_suggestion) == 'function') {
                            await handlers.assign_suggestion(true, null, assignment);
                        }
                        this.setBusy(false);
                    },
                    () => {
                        console.log('Assignment is locked, user dont want to unlock');
                    }
                );
            },
            subMenu: null,
            subMenuIsOpen: false,
        });
        this._menu.addAction({
            id: 'select_another_assignment',
            // label: `${assignToActionText} ${get(_)('another vehicle')}...`,
            label: select_another_assignment_label+'...',
            disabled: false,
            visible:
                DeliveriesMenuActions.deliveryCanBeRejected(this, assignment) ||
                !assignment.isDefault(),
            icon: IconVehicle,
            visibleInContextMenu: true,
            onClick: () => {
                unlockAssignmentIfPossible(
                    assignment,
                    () => {
                        import('../Modals/ModalSelectRoute.svelte').then((modalSelectRouteModule) => {
                            const ModalSelectRoute = modalSelectRouteModule.default;
                            console.log('Assignment is locked, but user want to unlock it');
                            openModal(ModalSelectRoute, {
                                onClick: (async (assignmentId: number|null, newAssignment: Assignment|null|undefined) => {
                                    console.log('ModalSelectRoute onClick async', assignmentId, newAssignment);
                                    // onRouteSelect 1328557 false 107801 Object { assignment: {…}, vehicle: {…}, maxDeliveriesPerRoute: 200, suggested_jobs: [], quickCategories: {…}, busy: false }
                                    if (newAssignment) {
                                        get(planning).lastUsedAssignment = newAssignment;
                                        planning.set(get(planning));
                                    }
                                    console.log('ModalSelectRoute onRouteSelect...', assignmentId, newAssignment);
                                    let routeOK = await DeliveriesBulkActions.onRouteSelect(
                                        this.getJobId(),
                                        this.hasSuggestedAssignment(),
                                        newAssignment.getId(),
                                        newAssignment
                                    );
                                    console.log('ModalSelectRoute onRouteSelect, close promise', routeOK);
                                    if (routeOK) {
                                        setTimeout((async function() {
                                            this.setBusy(true);
                                            if (typeof(handlers?.select_another_assignment) == 'function') {
                                                await handlers.select_another_assignment(false, assignment, newAssignment);
                                            }
                                            await DeliveriesBulkActions.doAssign(
                                                get(api),
                                                assignmentId,
                                                [this.getJobId()],
                                                'selected',
                                                {},
                                                get(planning).selectedDay
                                            );
                                            console.log('ModalSelectRoute assignment.reload', assignmentId, newAssignment);
                                            try {
                                                assignment = await assignment.reload();
                                                await this.loadByJobId(this.getJobId());
                                            } catch (e) {
                                                console.error(e);
                                            }
                                            if (typeof(handlers?.select_another_assignment) == 'function') {
                                                await handlers.select_another_assignment(true, assignment, newAssignment);
                                            }
                                            this.setBusy(false);
                                        }).bind(this), 0);
                                        return Promise.resolve(true);
                                    } else {
                                        return Promise.resolve(false);
                                    }
                                }).bind(this),
                                rejectedAssignments: this.getJobClass()?.getRejectedAssignments() ?? [],
                                excludedAssignments: [assignment.getId()],
                                selectedScenarioId: assignment.getScenarioId(),
                                vehicles: get(scenarioManager).getVehiclesData(),
                                jobId: this.getJobId(),
                                inProgressSwitch: false,
                                onlyLocked: false,
                                showCancelButton: true
                            });
                        });
                    },
                    () => {
                        console.log('Assignment is locked, user dont want to unlock');
                    }
                );
            },
            subMenu: null,
            subMenuIsOpen: false,
        });

        this._menu.addAction({
            id: 'reject',
            label: rejectActionText,
            disabled: false,
            visible: DeliveriesMenuActions.deliveryCanBeRejected(this, assignment),
            icon: IconRemoveWarning,
            visibleInContextMenu: true,
            onClick: () => {
                unlockAssignmentIfPossible(
                    assignment,
                    async () => {
                        // console.log('changeAssignments, reject, assId', assignment.getId());
                        this.setBusy(true);
                        this.setVisibility(false);
                        if (typeof(handlers?.reject) == 'function') {
                            await handlers.reject(false, assignment, null);
                        }
                        await DeliveriesBulkActions.doReject(
                            get(api),
                            [this.getJobId()],
                            'selected',
                            {},
                            assignment.getId(),
                            get(planning).selectedDay
                        ).catch(e => {
                            console.error('doReject', e);
                            this.setVisibility(true);
                        });
                        try {
                            assignment = await assignment.reload();
                            this.assignmentJob.assignment_id = 0;
                            this.assignmentJob.id = 0;
                        } catch (e) {
                            console.error(e);
                        }
                        if (typeof(handlers?.reject) == 'function') {
                            await handlers.reject(true, assignment, null);
                        }
                        this.setBusy(false);
                    },
                    () => {
                        console.log('Assignment is locked, user dont want to unlock');
                    }
                );
            },
            subMenu: null,
            subMenuIsOpen: false,
        });

        if (get(features).feature_ux_improvements) {
            this._menu.addAction({
                id: 'change_target_date',
                label: get(_)('change_target_date')+'...',
                disabled: false,
                visible:
                    DeliveriesMenuActions.deliveryCanBeRejected(this, assignment) ||
                    !assignment.isDefault(),
                icon: IconCalendar,
                visibleInContextMenu: true,
                onClick: () => {
                    unlockAssignmentIfPossible(
                        assignment,
                        () => {
                            import('../Modals/ModalSetTargetDate.svelte').then((modalSetTargetDate) => {
                                const ModalSetTargetDate = modalSetTargetDate.default;
                                openModal(ModalSetTargetDate, {
                                    text: get(_)(`Select target date for selected jobs`) + ` (1)`,
                                    onClick: (async () => {
                                        this.setBusy(true);
                                        this.setVisibility(false);
                                        if (typeof(handlers?.reject) == 'function') {
                                            await handlers.reject(false, assignment, null);
                                        }
                                        await DeliveriesBulkActions.doReject(
                                            get(api),
                                            [this.getJobId()],
                                            'selected',
                                            {},
                                            null,
                                            get(planning).selectedDay
                                        ).catch(e => {
                                            console.error('doReject', e);
                                            this.setVisibility(true);
                                        });
                                        await JobApi.modify(
                                            get(api),
                                            { id: { $in: [this.getJobId()] } },
                                            { target_date: get(jobs).defaultTargetDate }
                                        ).catch(e => {
                                            console.error('modify', e);
                                        });
                                        if (typeof(handlers?.reject) == 'function') {
                                            await handlers.reject(true, assignment, null);
                                        }
                                        this.setBusy(false);
                                    }).bind(this)
                                });
                            });
                        },
                        () => {
                            console.log('Assignment is locked, user dont want to unlock');
                        }
                    );
                },
                subMenu: null,
                subMenuIsOpen: false,
            });
        }

        return this._menu;
    }

}
